import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const CTASection = styled.section`
  padding: ${p => p.theme.spacing.xxl} ${p => p.theme.spacing.lg};
  background: ${p => p.theme.gradients.primary};
  position: relative;
  overflow: hidden;

  @media (max-width: ${p => p.theme.breakpoints.mobile}) {
    padding: ${p => p.theme.spacing.xl} ${p => p.theme.spacing.md};
  }
`;

const GlowOrb = styled.div`
  position: absolute;
  width: 600px; height: 600px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%);
  filter: blur(60px);
  pointer-events: none;
`;

const Orb1 = styled(GlowOrb)`top: -300px; right: -150px;`;
const Orb2 = styled(GlowOrb)`bottom: -300px; left: -150px;`;

const Container = styled.div`
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 2;
`;

const Title = styled(motion.h2)`
  font-size: clamp(1.75rem, 5vw, 3rem);
  font-weight: ${p => p.theme.typography.weights.extrabold};
  color: white;
  margin-bottom: ${p => p.theme.spacing.md};
  line-height: 1.15;
  letter-spacing: -0.02em;
`;

const Subtitle = styled(motion.p)`
  font-size: clamp(0.9375rem, 2vw, 1.125rem);
  color: rgba(255,255,255,0.92);
  margin-bottom: ${p => p.theme.spacing.lg};
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const ButtonRow = styled(motion.div)`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: ${p => p.theme.breakpoints.mobile}) {
    flex-direction: column;
    width: 100%;
  }
`;

const PrimaryButton = styled(motion.a)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  background: white;
  color: #8B5CF6;
  border: none;
  border-radius: 14px;
  font-size: 1.0625rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0,0,0,0.2);
  }

  @media (max-width: ${p => p.theme.breakpoints.mobile}) {
    padding: 14px 28px;
    font-size: 1rem;
    width: 100%;
    justify-content: center;
  }
`;

const CTA = () => {
  return (
    <CTASection>
      <Orb1 /><Orb2 />
      <Container>
        <Title
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.5 }}
        >
          Ready to upgrade your improvement work?
        </Title>

        <Subtitle
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}
        >
          Get early access to the full platform — certifications, AI tools, strategic planning, and team workflows in one connected workspace.
        </Subtitle>

        <ButtonRow
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.2 }}
        >
          <PrimaryButton
            href="https://continualabsdashboardd.netlify.app/login"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Get Started — Free →
          </PrimaryButton>
        </ButtonRow>
      </Container>
    </CTASection>
  );
};

export default CTA;
